import { handleActions } from 'redux-actions';
import defaultSettings from '@wix/wix-vod-shared/src/app-settings/default-settings';

import globalSettings from 'shared/settings';

import { APP_SETTINGS_UPDATE } from 'widget/redux/client/actions/app-settings';
import { migrateToLatestVersion } from '@wix/wix-vod-shared/src/app-settings/migration';
import { isNewInstallation, isLatestVersion } from 'shared/utils/app-settings';


const initialSettings = {
  booleans: {},
  colors: {},
  fonts: {},
  numbers: {},
  ...globalSettings,
};

export default handleActions({
  [APP_SETTINGS_UPDATE]: (state, { payload }) => {
    let currentSettings = _.merge({}, state, payload);

    if (!isNewInstallation(currentSettings) && !isLatestVersion(currentSettings)) {
      currentSettings = migrateToLatestVersion(currentSettings);
    }

    return _.merge(
      {},
      initialSettings,
      defaultSettings,
      currentSettings,
    );
  },
}, null);



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/app-settings.js